<script lang="ts">
	export let className = 'size-5';
</script>

<!--
	Source: Figma
	Copyright: unknown
	Origin: Figma
-->

<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor" class={className}>
  <path d="M14.1666 18.8889C13.9482 18.8889 13.7305 18.8039 13.5671 18.6345L5.78934 10.5789C5.47712 10.2562 5.47712 9.74394 5.78934 9.42116L13.5671 1.36561C13.8866 1.03505 14.4143 1.02561 14.7455 1.34505C15.0766 1.6645 15.0855 2.19227 14.766 2.52339L7.54712 10.0001L14.766 17.4767C15.0855 17.8078 15.0766 18.3356 14.7455 18.6551C14.5838 18.8112 14.3749 18.8889 14.1666 18.8889Z"/>
</svg>
